











import { Vue, Component, Prop } from "vue-property-decorator";
import { CategoryCodeFilter } from "@/data/filters/templates/slots";
import { IProduct } from "@/models/products";
import { TemplateObjectTypes } from "@/data/enums/templates";
import { UpmindObjectTypes } from "@/data/enums/objects";

@Component({
  components: {
    "client-templates-slots-provider": () =>
      import("@/components/app/admin/clientTemplates/slotsProvider.vue"),
    "client-templates-slots-listing": () =>
      import("@/components/app/admin/clientTemplates/slotsListing.vue")
  }
})
export default class AdminCatalogueProductTemplateSlots extends Vue {
  // Props

  @Prop({ required: true })
  public productId!: IProduct["id"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Computed

  public get slotsProviderProps() {
    return {
      handleLoading: false,
      objectId: this.productId,
      objectType: TemplateObjectTypes.PRODUCT,
      manualFilters: {
        ...CategoryCodeFilter([UpmindObjectTypes.CONTRACTS_PRODUCT])
      }
    };
  }
}
